import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { bookmarkAssetMigrations, bookmarkAssetValidator } from "../assets/TLBookmarkAsset";
import { imageAssetMigrations, imageAssetValidator } from "../assets/TLImageAsset";
import { videoAssetMigrations, videoAssetValidator } from "../assets/TLVideoAsset";
/** @internal */ export const assetValidator = T.model("asset", T.union("type", {
    image: imageAssetValidator,
    video: videoAssetValidator,
    bookmark: bookmarkAssetValidator
}));
/** @internal */ export const assetVersions = {
    AddMeta: 1
};
/** @internal */ export const assetMigrations = defineMigrations({
    subTypeKey: "type",
    subTypeMigrations: {
        image: imageAssetMigrations,
        video: videoAssetMigrations,
        bookmark: bookmarkAssetMigrations
    },
    currentVersion: assetVersions.AddMeta,
    migrators: {
        [assetVersions.AddMeta]: {
            up: (record)=>{
                return {
                    ...record,
                    meta: {}
                };
            },
            down: ({ meta: _, ...record })=>{
                return {
                    ...record
                };
            }
        }
    }
});
/** @public */ export const AssetRecordType = createRecordType("asset", {
    migrations: assetMigrations,
    validator: assetValidator,
    scope: "document"
}).withDefaultProperties(()=>({
        meta: {}
    }));
